import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { User } from '@jfw/angular/shared/firebase/auth';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { NavigationService } from '@jfw/angular/ecommerce/core';
import { Dealer, EnvVersion } from '@jfw/types';

interface DealerIdForm {
  dealerId: FormControl<string>;
}

@Component({
  selector: 'app-header-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIcon,
    MatIconButton,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    RouterLink,
  ],
})
export class HeaderMobileComponent {
  private readonly navigationService = inject(NavigationService);

  public readonly headerLogo = input.required<string>();

  public readonly headerTheme = input.required<string>();

  public readonly servedEnvironment = input.required<EnvVersion>();

  public readonly dealerIdForm = input.required<FormGroup<DealerIdForm>>();

  public readonly firebaseUser = input.required<User | null>();

  public readonly currentDealer = input.required<Dealer | null>();

  public readonly userDealers = input.required<Dealer[]>();

  public readonly displayName = input.required<string>();

  public readonly newSite = input.required<boolean>();

  // EXT-6239: shows the header feedback button.
  public readonly enableFeedback = input.required<boolean>();

  public readonly openFeedback = output<void>();

  public readonly newDefaultDealerId = output<string>();

  protected openHeaderNav(): void {
    this.navigationService.showHeaderNav(true);
  }

  // will re-enable search button when event search is enabled
  // public openSearchNav(): void {
  //   this.navigationService.showSearchNav(true);
  // }
}
